import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { StaffMember } from '../models/staff-member.model';
import { StaffConversation } from '../models/staff-conversation.model';
import { Message } from '../models/message.model';

@Injectable({ providedIn: 'root' })
export class StaffMessagingApiService {
  private baseUrl = environment.APP_BASE_URL + '/staff-portal/messaging';

  constructor(private http: HttpClient) {}

  getColleagues(): Observable<StaffMember[]> {
    return this.http.get<StaffMember[]>(`${this.baseUrl}/colleagues`);
  }

  getConversations(): Observable<StaffConversation[]> {
    return this.http.get<StaffConversation[]>(`${this.baseUrl}/conversations`);
  }

  getOrCreateConversation(otherUserId: string): Observable<StaffConversation> {
    return this.http.post<StaffConversation>(
      `${this.baseUrl}/conversations/with/${otherUserId}`,
      {},
    );
  }

  getMessages(conversationId: string): Observable<Message[]> {
    return this.http.get<Message[]>(`${this.baseUrl}/conversations/${conversationId}/messages`);
  }
}
